/*
 * errorForensics — TEMPORARY (installed 2026-08-21) global capture of
 * window.onerror / unhandledrejection, POSTed to the backend, so we get the
 * real exception behind the Safari "Script error." crash on the driver PWA
 * install flow instead of guessing. "Script error." with no filename/lineno
 * is the browser's own redaction for cross-origin script errors — this
 * captures everything the page CAN see (message/stack/filename/lineno when
 * available, standalone + service-worker state, current path) as evidence.
 * Remove once the root cause is confirmed fixed.
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api/diagnostics/client-error`;

function context() {
  let standalone = false, iosStandalone = false, swControlled = false, modalMounted = false;
  try { standalone = !!(window.matchMedia && window.matchMedia("(display-mode: standalone)").matches); } catch { /* */ }
  try { iosStandalone = window.navigator && window.navigator.standalone === true; } catch { /* */ }
  try { swControlled = !!(navigator.serviceWorker && navigator.serviceWorker.controller); } catch { /* */ }
  try { modalMounted = !!window.__ASTAT_INSTALL_MODAL_MOUNTED__; } catch { /* */ }
  return {
    pathname: window.location.pathname,
    href: window.location.href,
    user_agent: navigator.userAgent,
    display_mode_standalone: standalone,
    ios_navigator_standalone: iosStandalone,
    sw_controlled: swControlled,
    install_modal_mounted: modalMounted,
  };
}

function send(payload) {
  try {
    const body = JSON.stringify(payload);
    if (navigator.sendBeacon) {
      navigator.sendBeacon(API, new Blob([body], { type: "application/json" }));
    } else {
      fetch(API, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
    }
  } catch { /* logging must never itself throw */ }
}

export function installErrorForensics() {
  if (typeof window === "undefined" || window.__ASTAT_FORENSICS_INSTALLED__) return;
  window.__ASTAT_FORENSICS_INSTALLED__ = true;

  window.addEventListener("error", (event) => {
    send({
      kind: "error",
      message: event.message || null,
      stack: event.error && event.error.stack ? String(event.error.stack) : null,
      filename: event.filename || null,
      lineno: event.lineno || null,
      colno: event.colno || null,
      ...context(),
    });
  });

  window.addEventListener("unhandledrejection", (event) => {
    const reason = event.reason;
    send({
      kind: "unhandledrejection",
      message: reason && reason.message ? String(reason.message) : String(reason),
      stack: reason && reason.stack ? String(reason.stack) : null,
      ...context(),
    });
  });
}
